import WhoItsForImage from "@/assets/who-its-for-image.svg";

export function WhoItsFor() {
  const audiences = [
    "Parents & Teenagers",
    "Spouses, Partners & Couples",
    "Siblings & Extended Family",
    "Co-Workers",
    "Co-Parents",
    "Friends",
  ];

  return (
    <section id="who-its-for" className="bg-greyscale-light px-4 sm:px-6 md:px-10 lg:px-xl py-8 sm:py-12 md:py-16 lg:py-5xl">
      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-xl">
        <div className="space-y-6 sm:space-y-8 md:space-y-2xl">
          <div className="space-y-2 sm:space-y-sm">
            <h2 className="text-greyscale-default font-family-gabarito text-[28px] sm:text-[36px] md:text-[42px] lg:text-[48px] font-bold leading-[32px] sm:leading-[40px] md:leading-[48px] lg:leading-3xl">
              Who It's For
            </h2>
            <p className="text-greyscale-subtle font-family-reddit-sans text-base sm:text-lg md:text-xl leading-[22px] sm:leading-[24px] md:leading-[28px] max-w-[434px]">
              Dfuse supports many contexts where relationships matter and stakes
              are real
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-xs">
            {audiences.map((audience) => (
              <div
                key={audience}
                className="w-full px-4 sm:px-md py-3 sm:py-l rounded-[14px] text-greyscale-default font-family-gabarito text-base sm:text-lg md:text-xl font-medium leading-[22px] sm:leading-[24px] md:leading-[28px] bg-greyscale-white shadow-[0_10px_24px_0_rgba(0,0,0,0.06)]"
              >
                {audience}
              </div>
            ))}
          </div>
        </div>
        <img
          src={WhoItsForImage}
          alt="Who It's For"
          className="w-full h-full object-contain max-w-[500px] lg:max-w-none mx-auto"
        />
      </div>
    </section>
  );
}
